import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import ArticleCard from '@/components/feature/ArticleCard';
import VideoSection from './components/VideoSection';
import CTASection from './components/CTASection';
import { allArticles, siteInfo } from '@/mocks/articles';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '黑料吃瓜网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '黑料吃瓜网是国内领先的娱乐资讯聚合平台，汇聚51黑料吃瓜、91黑料吃瓜、网曝一区二区等热门入口，实时更新全网独家网红黑料、明星塌房现场与每日吃瓜爆料视频。',
      },
    },
    {
      '@type': 'Question',
      name: '黑料吃瓜网的内容可信吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '黑料吃瓜网每一条爆料均经过编辑团队的多方交叉验证，确保信息真实可靠。我们拒绝虚假谣言和恶意中伤，致力于为用户提供最真实的娱乐资讯。',
      },
    },
    {
      '@type': 'Question',
      name: '如何投稿爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过发送邮件至 tips@heiliaochigua.com 进行匿名投稿。我们采用严格的匿名投稿机制与信息加密技术，全方位保护爆料人隐私安全。',
      },
    },
    {
      '@type': 'Question',
      name: '黑料吃瓜网支持哪些平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '黑料吃瓜网覆盖51黑料吃瓜、91黑料吃瓜、网曝一区二区、明星塌房、网红黑料、吃瓜视频等多个频道，提供网页端和移动端全平台访问体验。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系黑料吃瓜网进行商务合作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '商务合作请联系 biz@heiliaochigua.com，我们将在48小时内回复。黑料吃瓜网日均访问量超过850万，是品牌推广的理想平台。',
      },
    },
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'https://www.heiliaochigua.com',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.heiliaochigua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://www.heiliaochigua.com',
  description: siteInfo.description,
  foundingDate: siteInfo.founded,
  slogan: siteInfo.slogan,
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${siteInfo.name} - 首页`,
  description: siteInfo.description,
  url: 'https://www.heiliaochigua.com',
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://www.heiliaochigua.com',
  },
};

export default function Home() {
  const latestArticles = allArticles.slice(0, 8);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />

        <CategoryNav />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="flex-1 min-w-0">
                <h2 className="text-2xl md:text-3xl font-black font-heading text-foreground-950 mb-8">
                  最新爆料
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {latestArticles.map((article) => (
                    <ArticleCard
                      key={article.id}
                      slug={article.slug}
                      title={article.title}
                      excerpt={article.excerpt}
                      category={article.category}
                      categorySlug={article.categorySlug}
                      imageUrl={article.imageUrl}
                      author={article.author}
                      avatar={article.avatar}
                      publishDate={article.publishDate}
                      readCount={article.readCount}
                      isHot={article.isHot}
                      isExclusive={article.isExclusive}
                    />
                  ))}
                </div>
              </div>

              <HotRanking />
            </div>
          </div>
        </section>

        <VideoSection />

        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}